import { loadModules } from 'esri-loader';
import BSLASortLayers from '../../helpers/BSLASortLayers';
import BSLABaldEagleLayer from './BSLABaldEagleLayer';
import BSLABonnetedBatLayer from './BSLABonnetedBatLayer';
import BSLABurrowingOwlCapeCoral from './BSLABurrowingOwlCapeCoralLayer';
import BSLAPantherFocusAreaLayer from './BSLAPantherFocusAreaLayer';
import BSLARedCockadedWoodpeckerLayer from './BSLARedCockadedWoodpeckerLayer';
import BSLASandSkinkAreaLayer from './BSLASandSkinkAreaLayer';
import BSLAScrubJayLayers from './BSLAScrubJayLayers';
import BSLAWoodstorkLayer from './BSLAWoodstorkLayer';
import { SPECIES_TITLE } from '../../BSLAConstants';

const BSLASpeciesLayers = async () => {
    const layers = [];

    const baldEagleLayer = await BSLABaldEagleLayer();
    if (baldEagleLayer) {
        layers.push(baldEagleLayer);
    }

    const batLayer = await BSLABonnetedBatLayer();
    if (batLayer) {
        layers.push(batLayer);
    }

    const burrowingOwlLayer = await BSLABurrowingOwlCapeCoral();
    if (burrowingOwlLayer) {
        layers.push(burrowingOwlLayer);
    }

    const pantherAreaLayer = await BSLAPantherFocusAreaLayer();
    if (pantherAreaLayer) {
        layers.push(pantherAreaLayer);
    }

    const redCockadedWoodpeckerLayer = await BSLARedCockadedWoodpeckerLayer();
    if (redCockadedWoodpeckerLayer) {
        layers.push(redCockadedWoodpeckerLayer);
    }

    const sandSkinkAreaLayer = await BSLASandSkinkAreaLayer();
    if (sandSkinkAreaLayer) {
        layers.push(sandSkinkAreaLayer);
    }

    const scrubJayLayers = await BSLAScrubJayLayers();
    if (scrubJayLayers) {
        layers.push(scrubJayLayers);
    }

    const woodstorkLayer = await BSLAWoodstorkLayer();
    if (woodstorkLayer) {
        layers.push(woodstorkLayer);
    }

    type layerModules = [typeof import('esri/layers/GroupLayer')];

    const [GroupLayer] = await (loadModules(['esri/layers/GroupLayer']) as Promise<layerModules>);

    return new GroupLayer({
        title: SPECIES_TITLE,
        layers: layers.sort(BSLASortLayers)
    });
};

export default BSLASpeciesLayers;
